import { useId, useState, type FormEvent } from 'react';

import { Botao } from '@/componentes/Botao';

import { useUtilidade } from './utilidade';

/**
 * "Esta resposta serviu?" debaixo de cada resposta da IA na mesa (etapa C;
 * guia 6.3: utilidade de pelo menos 80 por cento entre os usuarios piloto).
 *
 * So aparece para quem pediu a resposta — a tela de quem chama decide, com o
 * `minha` que o servidor devolve; a rota e o banco recusam o resto. Os dois
 * botoes ficam com `aria-pressed`, e o motivo do "nao serviu" e opcional.
 */
export function UtilidadeDaResposta({ perguntaId, inicial }: { readonly perguntaId: string; readonly inicial?: boolean | null }) {
  const base = useId();
  const u = useUtilidade(perguntaId, inicial);
  const [motivo, setMotivo] = useState('');

  const enviar = (e: FormEvent) => {
    e.preventDefault();
    u.enviarMotivo(motivo);
    setMotivo('');
  };

  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-wrap items-center gap-2">
        <span className="txt-apoio text-tinta-secundaria" id={`${base}-pergunta`}>
          Esta resposta serviu?
        </span>
        <div role="group" aria-labelledby={`${base}-pergunta`} className="flex gap-2">
          <Botao tamanho="p" nivel="secundario" aria-pressed={u.nota?.util === true} disabled={u.ocupado} onClick={u.serviu}>
            Marcar como útil
          </Botao>
          <Botao tamanho="p" nivel="secundario" aria-pressed={u.nota?.util === false} disabled={u.ocupado} onClick={u.naoServiu}>
            Marcar como não útil
          </Botao>
        </div>
        {u.nota ? (
          <span className="txt-apoio text-tinta-apagada" role="status">
            {u.nota.util ? 'Marcado: serviu.' : u.nota.motivo ? 'Marcado: não serviu, com o motivo.' : 'Marcado: não serviu.'}
          </span>
        ) : null}
      </div>
      {u.pedindoMotivo ? (
        <form onSubmit={enviar} className="flex flex-col gap-2">
          <label className="flex flex-col gap-1" htmlFor={`${base}-motivo`}>
            <span className="txt-apoio text-tinta-secundaria">O que faltou, em poucas palavras · opcional</span>
            <input
              id={`${base}-motivo`}
              className="controle w-full"
              maxLength={500}
              value={motivo}
              placeholder="A resposta citou o manual de outro modelo"
              onChange={(e) => {
                setMotivo(e.target.value);
              }}
            />
          </label>
          <Botao tamanho="m" nivel="secundario" type="submit" className="self-end" disabled={motivo.trim().length < 3 || u.ocupado}>
            Enviar o motivo
          </Botao>
        </form>
      ) : null}
    </div>
  );
}
